@if (meta(); as m) {
  <div
    [class]="
      compact()
        ? 'flex items-start gap-1.5 text-xs'
        : 'rounded-md border px-3 py-2.5 flex items-start gap-2 text-sm'
    "
    [class.border-danger]="m.icon === 'error'"
    [class.bg-danger-soft]="m.icon === 'error' && !compact()"
    [class.text-danger]="m.icon === 'error'"
    [class.border-warning]="m.icon === 'warning'"
    [class.bg-warning-soft]="m.icon === 'warning' && !compact()"
    [class.text-warning]="m.icon === 'warning'"
    [class.border-primary]="m.icon === 'info'"
    [class.bg-accent]="m.icon === 'info' && !compact()"
    [class.text-accent-foreground]="m.icon === 'info'"
  >
    <ng-icon
      [name]="iconName()"
      [class]="compact() ? 'size-3.5 shrink-0 mt-0.5' : 'size-4 shrink-0 mt-0.5'"
    />
    <div class="min-w-0">
      <p class="font-normal leading-snug">{{ m.title }}</p>
      @if (!compact()) {
        <p class="mt-0.5 text-xs opacity-80 leading-snug">{{ m.description }}</p>
        @if (displayDetail()) {
          <p class="mt-1 text-xs opacity-70 leading-snug italic">{{ displayDetail() }}</p>
        }
        @if (retryable()) {
          <p class="mt-1 text-xs opacity-70">Dieser Schritt kann erneut gestartet werden.</p>
        }
      }
    </div>
  </div>
}
